import ToggleSwitch from "Common/ToggleSwitch";
import { formatNumber } from "pages/MatchDetail/MatchedOdds";
import { useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";

interface FancyBookProps {
  show: any;
  setFancyBook: any;
  fancyRunData: any;
  fancyName: string;
}

const FancyBook = ({
  show,
  setFancyBook,
  fancyName,
  fancyRunData,
}: FancyBookProps) => {
  const [showToggle, setShowToggle] = useState(true);



  // useEffect(() => {
  //   if (fancyRunData && fancyRunData.length > 0) {
  //     const calculateFancyPosition = () => {
  //       let fancyPosData: any[] = [];

  //       for (let i = 0; i < fancyRunData.length; i++) {
  //         const element = fancyRunData[i];

  //         if (element.key == "0" || element.key == 0) {
  //           fancyPosData[0] = element;
  //         } else {
  //           if (i === 0) {
  //             const a = element.key.split("-");
  //             const b = {
  //               key: parseInt(a[1]) - 1,
  //               value: element.value,
  //               valueFull: element.valueFull,
  //             };
  //             const d = {
  //               key: parseInt(a[1]),
  //               value: element.value,
  //               valueFull: element.valueFull,
  //             };
  //             fancyPosData[0] = b;
  //             fancyPosData[1] = d;
  //           } else if (i > 0 && i < fancyRunData.length - 1) {
  //             if (element.key.includes("-")) {
  //               const [k, l] = element.key.split("-").map(Number);
  //               for (let j = k; j <= l; j++) {
  //                 fancyPosData.push({
  //                   key: j,
  //                   value: element.value,
  //                   valueFull: element.valueFull,
  //                 });
  //               }
  //             } else {
  //               fancyPosData.push({
  //                 key: parseInt(element.key),
  //                 value: element.value,
  //                 valueFull: element.valueFull,
  //               });
  //             }
  //           } else {
  //             if (element.key.includes("+")) {
  //               const [val] = element.key.split("+").map(Number);
  //               const b = {
  //                 key: val,
  //                 value: element.value,
  //                 valueFull: element.valueFull,
  //               };
  //               fancyPosData.push(b);

  //               if (fancyRunData[0].key !== "0") {
  //                 const d = {
  //                   key: val + 1,
  //                   value: element.value,
  //                   valueFull: element.valueFull,
  //                 };
  //                 fancyPosData.push(d);
  //               }
  //             } else {
  //               const val = parseInt(element.key);
  //               fancyPosData.push({
  //                 key: val,
  //                 value: element.value,
  //                 valueFull: element.valueFull,
  //               });
  //               fancyPosData.push({
  //                 key: val + 1,
  //                 value: element.value,
  //                 valueFull: element.valueFull,
  //               });
  //             }
  //           }
  //         }
  //       }

  //       setFancyPositionData(fancyPosData);
  //     };

  //     calculateFancyPosition();
  //   }
  // }, [fancyRunData]);


  return (
    <Modal
      size="lg"
      show={show}
      onHide={() => setFancyBook(false)}
      className="zoomIn"
      scrollable
    >
      <Modal.Header className="modal-title fw-bold d-flex justify-content-between pb-1">
        <div className="d-flex align-items-center flex-wrap">
          Fancy Position{" "}
          <span className="text-muted fs-xs fw-normal mx-0 mx-sm-2 fs-xs">
            {fancyName}
          </span>
          <ToggleSwitch
            On="S"
            Off="F"
            id="fancy_book"
            onChange={() => setShowToggle(!showToggle)}
            checked={showToggle ? true : false}
          />
        </div>
        <Button variant="light btn-sm" onClick={() => setFancyBook(false)}>
          <i className="ri-close-line fs-xl align-middle"></i>
        </Button>
      </Modal.Header>
      <Modal.Body className="fs-md">
        <div className="table-responsive">
          <Table className="table-striped table-nowrap table-bordered text-center align-middle mb-0">
            <thead>
              <tr>
                <th scope="col">Runs</th>
                <th scope="col">P&L</th>
              </tr>
            </thead>
            <tbody>
              {fancyRunData && fancyRunData?.map((items: any) => {
                return (
                  <tr>
                    <td>{items?.key}</td>
                    <td
                      className={
                        Number(showToggle ? items?.value : items?.valueFull) >=
                        0
                          ? "text-success"
                          : "text-danger"
                      }
                    >
                      {showToggle
                        ? formatNumber(String(items?.value))
                        : formatNumber(String(items?.valueFull))}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FancyBook;
